import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Redirect } from 'react-router'
import PropTypes from 'prop-types'
import { trackHomeDigestView } from 'src/actions/trackingSource'
import { selectHomeId } from 'src/store/selectors/home'
import { selectCustomerLegacyRef } from 'src/store/selectors/customerProfile'
import { selectShowTeaserWindow } from 'src/store/selectors/client'
import Dashboard from 'src/Components/homeowners/Dashboard'
import WarningModal from 'src/Components/homeowners/WarningModal'
import OverlayMask from 'src/Components/shared/Routing/OverlayMask'
import { If, Unless } from 'src/Components'
import AuthError from 'src/features/auth/AuthError'
import Footer from 'src/Components/homeowners/Footer'
import Intro from 'src/Components/homeowners/Intro'
import Header from 'src/Components/homeowners/Header'
import AgentNavigation from 'src/App/AgentNavigation'
import Loading from 'src/Components/shared/Loading/LoadingApp'
import TeaserWindow from 'src/Components/shared/EstimatedValue/Warnings/TeaserWindow'

const propTypes = {
  errorModal: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.node,
    PropTypes.bool
  ]),
  notFound: PropTypes.bool,
  homeLoading: PropTypes.bool,
  mortgageRatesLoading: PropTypes.bool,
  match: PropTypes.shape({
    path: PropTypes.string,
    url: PropTypes.string,
    isExact: PropTypes.bool,
    params: PropTypes.object
  })
}

const HomeownerDigest = ({
  errorModal,
  notFound,
  homeLoading,
  mortgageRatesLoading,
  match
}) => {
  const dispatch = useDispatch()
  const [tracked, setTracked] = useState([])
  const homeId = useSelector(selectHomeId)
  const agentId = useSelector(selectCustomerLegacyRef)
  const teaserActive = useSelector(selectShowTeaserWindow)

  const showTeaser = teaserActive && false // time out - hard stop for now

  const loading = homeLoading || mortgageRatesLoading
  const shouldTrack = Boolean(
    agentId && homeId && !loading && !tracked.includes(homeId)
  )
  const showLoading = Boolean(!errorModal && loading)

  useEffect(() => {
    if (shouldTrack) {
      dispatch(trackHomeDigestView())
      setTracked([...tracked, homeId])
    }
  }, [homeId, shouldTrack, dispatch, tracked])

  return (
    <>
      <If condition={showLoading}>
        <Loading />
      </If>
      <Unless condition={showLoading}>
        <OverlayMask isExact={match.isExact}>
          <Header />
          <AgentNavigation />
          <If condition={!errorModal}>
            <Intro />
            <Dashboard subdue={!match.isExact} />
            <Footer />
            <TeaserWindow active={showTeaser} />
            <WarningModal />
          </If>
        </OverlayMask>
        <AuthError />
        <If condition={notFound}>
          <Redirect to='/not-found' />
        </If>
      </Unless>
    </>
  )
}

HomeownerDigest.propTypes = propTypes

export default HomeownerDigest
